import type { PropsWithChildren, ReactNode } from 'react';
import cx from 'classnames';
import { useHeaderContext } from '../../context/header-context';

type DesktopTopSectionProps = {
  className?: string;
  leadingChildClassname?: string;
  leadingChild?: ReactNode;
  trailingChildClassname?: string;
  trailingChild?: ReactNode;
} & PropsWithChildren;

export const DesktopTopSection = ({
  className,
  children,
  leadingChildClassname,
  leadingChild,
  trailingChildClassname,
  trailingChild,
}: DesktopTopSectionProps) => {
  const {
    visual: { isFluid },
  } = useHeaderContext();

  return (
    <div
      className={cx('osc-nav-top-link-area', {
        'container-fluid': isFluid,
        container: !isFluid,
      })}
    >
      <div className={cx('relative flex flex-wrap', className)}>
        {leadingChild != null && (
          <div className={leadingChildClassname} data-testid="header-desktop-top-section-leading">
            {leadingChild}
          </div>
        )}
        {trailingChild != null && (
          <div
            className={cx('flex-1', trailingChildClassname)}
            data-testid="header-desktop-top-section-trailing"
          >
            {trailingChild}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
